import React, { useContext } from 'react'
import type { ReactNode } from 'react'

import PermissionErrorMessage from '../permissionErrorMessage'
import { AuthContext } from 'contexts/auth'
import { Permissions } from 'api'


type Props = {
  include: string;
  children: ReactNode;
  showError?: boolean;
};

const Permission = ({
  include = '',
  children,
  showError = false,
}: Props) => {
// @ts-expect-error - TS2339 - Property 'authorization' does not exist on type 'unknown'.
  const { authorization } = useContext(AuthContext)

  return Permissions.hasPermission(authorization, include) ? <>{children}</> : (showError ? <PermissionErrorMessage /> : null)
}

export default Permission
